import React from 'react'

export function TitleBarLeftContainer({
  children,
}: {
  readonly children: React.ReactNode
}) {
  return (
    <div
      className={'col-start-1 row-start-1 flex justify-start gap-2.5 md:gap-5'}
    >
      {children}
    </div>
  )
}
